export default __webpack_public_path__ + "static/media/Loading_Dye_LD.2ba8e854.svg";